export default "__VITE_ASSET__Skgc7rvW__"